import { render, staticRenderFns } from "./Bloco.vue?vue&type=template&id=532d6dca&scoped=true"
import script from "./Bloco.vue?vue&type=script&lang=js"
export * from "./Bloco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532d6dca",
  null
  
)

export default component.exports